var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBwicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0073 0H0V21.9958H22.0073V0Z",
    fill: "#FF9E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2821 4.68728V3.75085H9.72522V4.5017V9.07317H12.2821V4.68728Z",
    fill: "#232323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72522 14.6134V17.9232H12.2821V14.7989V12.6009H9.72522V14.6134Z",
    fill: "#232323"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0927 9.55841H12.7676V12.1157H18.0927V9.55841Z",
    fill: "#232323"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23804 9.55841H3.91296V12.1157H9.23804V9.55841Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBwicon);
export default __webpack_public_path__ + "static/media/bwicon.a01214ce2ed91c17ca16e1565b64b2a0.svg";
export { ForwardRef as ReactComponent };